import React from 'react'
import { VideoLoader } from '../VideoLoader'
import { VideoContainer } from './VideoContainer'
import { VideoScrubber } from './VideoScrubber'
import { VideoPlayback } from './VideoPlayback'
import { VideoVolume } from './VideoVolume'
import { VideoSpacer } from './VideoSpacer'
import { VideoClosedCaptions } from './VideoClosedCaptions'
import { VideoAudioTracks } from './VideoAudioTracks'
import { VideoFullscreen } from './VideoFullscreen'

/**
 * A limited set of controls for a smaller video player.
 * Includes a loader, progress bar, play/pause, volume,
 * cc, audio tracks, and fullscreen controls
 */
export const VideoControlsSmall = () => (
  <>
    <VideoLoader />
    <VideoContainer>
      <VideoScrubber />
      <VideoPlayback />
      <VideoVolume />
      <VideoSpacer />
      <VideoClosedCaptions />
      <VideoAudioTracks />
      <VideoFullscreen />
    </VideoContainer>
  </>
)
